export default "__VITE_ASSET__BfsAql4q__"